import React from 'react';
import { Check, Users, ArrowRight } from 'lucide-react';
import { pricing } from '../../data/mock';

const PricingSection = () => {
  return (
    <section id="pricing" className="bg-bg-primary py-20 lg:py-32">
      <div className="px-6 lg:px-12 xl:px-20">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-text-primary leading-tight mb-6">
              {pricing.title}
            </h2>
            <p className="text-lg text-text-secondary max-w-2xl mx-auto">
              {pricing.intro}
            </p>
          </div>

          {/* Pricing Card */}
          <div className="grid lg:grid-cols-2 gap-0 max-w-4xl mx-auto">
            {/* Left - Price */}
            <div className="bg-black text-white p-10 lg:p-16 flex flex-col justify-center">
              <p className="text-white/60 mb-4">If you decide to use it:</p>
              <div className="mb-8">
                <span className="text-6xl lg:text-7xl font-medium">{pricing.mainPrice.amount}</span>
                <span className="text-xl text-white/70 ml-2">{pricing.mainPrice.period}</span>
              </div>

              <div className="space-y-3 mb-8">
                {pricing.mainPrice.includes.map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <Check className="w-5 h-5 text-accent-green" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>

              <div className="flex items-center gap-3 text-white/70">
                <Users className="w-5 h-5" />
                <span className="text-sm">
                  Additional users: {pricing.additionalUsers.price} {pricing.additionalUsers.note}
                </span>
              </div>
            </div>

            {/* Right - Benefits */}
            <div className="bg-bg-secondary p-10 lg:p-16 flex flex-col justify-center">
              <div className="space-y-6 mb-10">
                {pricing.benefits.map((benefit, index) => (
                  <div key={index} className="flex items-center gap-4">
                    <div className="w-3 h-3 bg-accent-orange" />
                    <span className="text-lg text-text-primary font-medium">{benefit}</span>
                  </div>
                ))}
              </div>

              <p className="text-text-secondary mb-8">{pricing.footer}</p>

              <button
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="inline-flex items-center gap-3 bg-accent-orange text-white px-8 py-4 font-medium hover:bg-accent-orange/90 transition-colors w-fit"
              >
                Get Started
                <ArrowRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
